import { createFileRoute } from "@tanstack/react-router";
import { routeMeta } from "@/lib/route-meta";
import Install from "@/pages/Install";

export const Route = createFileRoute("/install")({ head: () => routeMeta('Install MNRE', 'Install the MNRE property app for convenient access.', '/install'), component: Install });
